/*
 * @Author: Teemo Ding
 * @Date: 2021-08-11 17:42:55
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-07 10:44:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/Subscription/index.tsx
 */

import { Button, ModalFooter, SizeFittingTable } from '@/src/components/Antd';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import {
  request_addSubscription,
  request_deleteSubscription,
} from '@/src/request/customer/customerDetail';
import { message } from 'antd';
import React, { Fragment, useState } from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import VisibilityToggle from 'src/components/VisibilityToggle';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import RemovePopup from '../../Components/RemovePopup';
import { subscriptionColumns } from '../config';
import css from '../css.module.less';

const permissions = () => {
  const send_account_invite = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.send_account_invite,
      }),
    ],
  });
  const delete_subscription = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.delete_subscription,
      }),
    ],
  });
  return {
    send_account_invite,
    delete_subscription,
  };
};

interface IParams {
  customerDatabaseUuid: string;
  customerUuid: string;
}
const Subscription = ({
  subscription,
  setShowModal,
  setModalTitle,
  setModalContent,
  reloadData,
  haveEmail,
  timezoneInGMT,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { send_account_invite, delete_subscription } = permissions();
  const { customerDatabaseUuid, customerUuid } = useParams<IParams>();
  const [show, setShow] = useState(false);
  const onDelete = (uuid) => {
    request_deleteSubscription(uuid).then(() => {
      message.success(getI18n('customerList.subscription.successfullyremoved'));
      setShowModal(false);
      reloadData(['Subscription', 'TimeLine']);
    });
  };

  const onAdd = () => {
    if (haveEmail) {
      request_addSubscription(customerUuid).then(() => {
        message.success(
          getI18n('customerList.subscription.successfullyremoved'),
        );
        setShowModal(false);
        reloadData(['Subscription', 'TimeLine']);
      });
    } else {
      setShowModal(false);
    }
  };

  const handleSubscribeCustomer = () => {
    setShowModal(true);
    setModalTitle(getI18n('customerList.subscription.subscribeCustomer'));
    setModalContent(
      <div>
        <p className={css.subscribeCustomerContent}>
          {haveEmail
            ? getI18n('customerList.subscription.desc1')
            : getI18n('customerList.subscription.desc2')}
        </p>
        <ModalFooter
          okText={haveEmail ? 'Confirm' : 'ok'}
          onOk={onAdd}
          {...(haveEmail && { onCancel: () => setShowModal(false) })}
        />
      </div>,
    );
  };

  const handleDelete = (record) => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('customerList.customerPrivacy.removeSubscription')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <RemovePopup
        type='Subscriber'
        onDelete={() => onDelete(record.uuid)}
        onCancel={() => setShowModal(false)}
      />,
    );
  };
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.informationContainer} ${css.wrapperContainer}`}
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>
              {getI18n('customerTag.subscription.subscriptionstatus')}
            </span>
            <VisibilityToggle defaultVisible={false} onToggle={setShow} />
          </div>
        }>
        {!subscription.length ? (
          <Fragment>
            <p>{getI18n('customerList.subscription.desc3')}</p>
            <Button
              type='primary'
              onClick={handleSubscribeCustomer}
              disabled={!send_account_invite}>
              {getI18n('customerList.subscription.subscribeCustomer')}
            </Button>
          </Fragment>
        ) : (
          <SizeFittingTable
            columns={subscriptionColumns(
              customerDatabaseUuid,
              handleDelete,
              timezoneInGMT,
              delete_subscription,
              { getI18n },
              show,
            )}
            pagination={false}
            id='subscriptionTable'
            rowKey='uuid'
            dataSource={subscription}
          />
        )}
      </SectionWrapper>
    </div>
  );
};

export default Subscription;
